import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Redirect } from "react-router";
import { withTranslation } from "react-i18next";
import PoliticianForm from "./Parts/PoliticianForm";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import { SelectField, YesNoRadio } from "../Fields";
import Loading from "./Parts/Loading";
import InputAddress from "../Partials/InputAddress";
import { IDENTITY_DOCUMENT_TYPES } from "../../constants";

class AML extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                address: '',
                account: '',
                subj_doc_type: '',
                subj_doc_number: '',
                subj_doc_issue_dt: '',
                subj_doc_exp_dt: '',
                occupation_info: '',
                working_place: '',
                position: '',
                act_field: '',
                other_desc: '',
                is_iban_owner: true,
                politician_form: {
                    is_politician: false,

                    pep_position_type: '',
                    full_name: '',
                    country: '',
                    institution: '',
                    position: '',

                    politician_me: true,
                    politician_family: false,
                    politician_associate: false,
                },
                representative_politician_form: {
                     is_politician: false,

                    full_name: '',
                    country: '',
                    institution: '',
                    position: '',

                    politician_me: true,
                    politician_family: false,
                    politician_associate: false,
                },
                representative_form: {
                    full_name: '',
                    code: '',
                    cntr_reg: '',
                    phone: '',
                    email: '',
                    address: '',
                    birth_dt: '',
                    doc_type: '',
                    doc_number: '',
                    doc_issue_dt: '',
                    doc_exp_dt: '',
                    auth_doc_number: '',
                    auth_doc_exp_dt: '',
                }
            },
            step_count: 4,
            current_step: 2,

            redirectToNextStep: false
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.canSubmit = this.canSubmit.bind(this);

        axios.post('/api/process/' + this.props.application_token + '/last_step', {step: 'aml'})
            .then(
                data => {
                },
                error => {
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    canSubmit(prop) {
        if (prop.values.politician_form.is_politician)
        {
            if(!this.isValidCountry(prop.values.politician_form.country)
                || prop.values.politician_form.pep_position_type === ''
                || prop.values.politician_form.pep_position_type === 'none'
                || prop.values.politician_form.institution === '') {
                return false;
            }

            if ((prop.values.politician_form.politician_associate || prop.values.politician_form.politician_family)
            && prop.values.politician_form.full_name === '') {
                return false;
            }

            if (!prop.values.politician_form.politician_associate
                && !prop.values.politician_form.politician_family
                && !prop.values.politician_form.politician_me) {
                return false;
            }
        }

        if (!prop.values.is_iban_owner
            && prop.values.representative_politician_form.is_politician
            && !this.isValidCountry(prop.values.representative_politician_form.country)
        ) {
            return false;
        }

        // Disable submit button for eshop
        return prop.values.is_iban_owner;
    }

    isValidCountry(country) {
        let goodCountries = [
            "Airija",
            "Austrija",
            "Belgija",
            "Bulgarija",
            "Čekija",
            "Danija",
            "Estija",
            "Graikija",
            "Ispanija",
            "Italija",
            "Jungtinė Karalystė",
            "Kipras",
            "Kroatija",
            "Latvija",
            "Lenkija",
            "Lietuva",
            "Liuksemburgas",
            "Мalta",
            "Nyderlandai",
            "Portugalija",
            "Prancūzija",
            "Rumunija",
            "Slovakija",
            "Slovėnija",
            "Suomija",
            "Švedija",
            "Vengrija",
            "Vokietija",
            "Islandija",
            "Lichtenšteinas",
            "Norvegija",
        ];

        return goodCountries.includes(country)
    }

    renderForm(props) {
        return (
            <div>
                <Header title={this.props.t('step.contract')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.aml')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>

                        {this.props.suggestion.is_eshop === null || !this.props.suggestion.application.client ?
                            <Loading/>
                            :
                            <Form className="form form-layout ">
                                    <div>
                                        <div className="container form-layout__2-col py-5">
                                            {!this.props.suggestion.is_eshop &&
                                            <div className="form-group col-md-6 col-lg-6">
                                                <label htmlFor="account">{this.props.t('forms.account')}</label>
                                                <Field type="text"
                                                       name="account"
                                                       id="account"
                                                       className={'form-control' + (props.errors.account && props.touched.account ? ' is-invalid' : '')}
                                                />
                                                <ErrorMessage name="account" component="div"
                                                              className="invalid-feedback"/>
                                                <p className="text-muted mb-0 mt-2">LT12 1234 1234 1234 1234</p>
                                            </div>
                                            }

                                            <div
                                                className={"form-group " + (this.props.suggestion.is_eshop ? "col-12" : "col-md-6 col-lg-6")}>
                                                <label htmlFor="address">{this.props.t('forms.address')}</label>
                                                <InputAddress
                                                    formikProps={props}
                                                    setAddressCorrect={value => {}}
                                                    setAddressChanged={value => {}}
                                                    // initialAddress={}
                                                />
                                                <p className="text-muted mb-0 mt-2">{this.props.t('forms.address_example')}</p>
                                            </div>

                                            <div className="form-group col-md-6 col-lg-6">
                                                <SelectField
                                                    label={this.props.t('forms.subj_doc_type')}
                                                    name="subj_doc_type"
                                                    options={ IDENTITY_DOCUMENT_TYPES }
                                                    {...props}
                                                />
                                            </div>

                                            <div className="form-group col-md-6 col-lg-6">
                                                <label htmlFor="input4">{this.props.t('forms.subj_doc_number')}</label>
                                                <Field type="text"
                                                       name="subj_doc_number"
                                                       id="subj_doc_number"
                                                       className={'form-control' + (props.errors.subj_doc_number && props.touched.subj_doc_number ? ' is-invalid' : '')}
                                                />
                                                <ErrorMessage name="subj_doc_number" component="div"
                                                              className="invalid-feedback"/>
                                            </div>

                                            <div className="form-group col-md-6 col-lg-6">
                                                <label
                                                    htmlFor="subj_doc_issue_dt">{this.props.t('forms.subj_doc_issue_dt')}</label>
                                                <Field type="text"
                                                       name="subj_doc_issue_dt"
                                                       id="subj_doc_issue_dt"
                                                       className={'form-control' + (props.errors.subj_doc_issue_dt && props.touched.subj_doc_issue_dt ? ' is-invalid' : '')}
                                                />
                                                <ErrorMessage name="subj_doc_issue_dt"
                                                              component="div"
                                                              className="invalid-feedback"/>
                                                <p className="text-muted mb-0 mt-2">Pvz.: 2010-05-01</p>
                                            </div>

                                            <div className="form-group col-md-6 col-lg-6">
                                                <label
                                                    htmlFor="subj_doc_exp_dt">{this.props.t('forms.subj_doc_exp_dt')}</label>
                                                <Field type="text"
                                                       name="subj_doc_exp_dt"
                                                       id="subj_doc_exp_dt"
                                                       className={'form-control' + (props.errors.subj_doc_exp_dt && props.touched.subj_doc_exp_dt ? ' is-invalid' : '')}
                                                />
                                                <ErrorMessage name="subj_doc_exp_dt" component="div"
                                                              className="invalid-feedback"/>
                                                <p className="text-muted mb-0 mt-2">Pvz.: 2020-05-01</p>
                                            </div>

                                            <div className="form-group col-12">
                                                <SelectField
                                                    label={this.props.t('forms.occupation_info')}
                                                    name="occupation_info"
                                                    options={{
                                                        'Samdomas darbuotojas': 'Samdomas darbuotojas',
                                                        'Besiverčiantis individualia veikla ar verslu': 'Besiverčiantis individualia veikla ar verslu',
                                                        'Galiojantis verslo liudijimas': 'Galiojantis verslo liudijimas',
                                                        'Galiojanti individualios veiklos pažyma': 'Galiojanti individualios veiklos pažyma',
                                                        'Kita veikla': 'Kita veikla',
                                                    }}
                                                    {...props}
                                                />
                                            </div>

                                            {props.values.occupation_info === 'Samdomas darbuotojas' ?
                                                <Fragment>
                                                    <div className="form-group col-md-6 col-lg-6">
                                                        <label
                                                            htmlFor="working_place">{this.props.t('forms.working_place')}</label>
                                                        <Field type="text"
                                                               name="working_place"
                                                               id="working_place"
                                                               className={'form-control' + (props.errors.working_place && props.touched.working_place ? ' is-invalid' : '')}
                                                        />
                                                        <ErrorMessage name="working_place" component="div"
                                                                      className="invalid-feedback"/>
                                                    </div>

                                                    <div className="form-group col-md-6 col-lg-6">
                                                        <label
                                                            htmlFor="position">{this.props.t('forms.position')}</label>
                                                        <Field type="text"
                                                               name="position"
                                                               id="position"
                                                               className={'form-control' + (props.errors.position && props.touched.position ? ' is-invalid' : '')}
                                                        />
                                                        <ErrorMessage name="position" component="div"
                                                                      className="invalid-feedback"/>
                                                    </div>
                                                </Fragment>
                                                :
                                                ''
                                            }

                                            {props.values.occupation_info === 'Besiverčiantis individualia veikla ar verslu' ?
                                                <div className="form-group col-md-6 col-lg-6">
                                                    <label htmlFor="act_field">{this.props.t('forms.act_field')}</label>
                                                    <Field type="text"
                                                           name="act_field"
                                                           id="act_field"
                                                           className={'form-control' + (props.errors.act_field && props.touched.act_field ? ' is-invalid' : '')}
                                                    />
                                                    <ErrorMessage name="act_field" component="div"
                                                                  className="invalid-feedback"/>
                                                </div>
                                                :
                                                ''
                                            }

                                            {props.values.occupation_info === 'Kita veikla' ?
                                                <div className="form-group col-md-12 col-lg-12">
                                                    <label
                                                        htmlFor="other_desc">{this.props.t('forms.other_desc')}</label>
                                                    <Field type="text"
                                                           name="other_desc"
                                                           id="other_desc"
                                                           className={'form-control' + (props.errors.other_desc && props.touched.other_desc ? ' is-invalid' : '')}
                                                    />
                                                    <ErrorMessage name="other_desc" component="div"
                                                                  className="invalid-feedback"/>
                                                </div>
                                                :
                                                ''
                                            }

                                        </div>
                                        <div className="border-bottom w-100 border-gray-cloud"></div>
                                    </div>

                                <div className="container form-layout__2-col py-5">
                                    <div className="col-12">
                                        <YesNoRadio label={this.props.t('forms.i_am_iban_owner')}
                                                    name={'is_iban_owner'}
                                                    {...props}
                                        />
                                    </div>
                                </div>
                                <div className="border-bottom w-100 border-gray-cloud"></div>
                                <div className="container form-layout__2-col py-5">
                                    <PoliticianForm
                                        data={this.state.data.politician_form}
                                        applicationToken={this.props.application_token}
                                        type="politician_form"
                                        {...props}
                                    />
                                </div>
                                <div className="container form-layout__2-col">
                                    {!props.values.is_iban_owner &&
                                        <div className="row">
                                            <div className="col-12 text-center mt-0">
                                                <p className="text-danger light mb-2">
                                                    {this.props.t('forms.not_iban_owner_error')}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-12 d-flex justify-content-center">
                                        <button name="submit"
                                                type="submit"
                                                value="id_card"
                                                className="btn btn-primary btn-lg"
                                                disabled={!this.canSubmit(props)}
                                        >
                                            {this.props.t('forms.next')}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        }
                    </div>
                </div>
            </div>
        );
    }

    formSubmit(values, actions) {
        axios.post('/api/process/' + this.props.application_token + '/aml', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        gtm.sendEvent('base', {
                            orderID: this.props.suggestion.application.id,
                            event: 'checkoutcontract1',
                            actionField: { step: 7, action: 'amlAdded' },
                            products: {
                               product_code: this.props.suggestion.eshop_data.appl_product,
                            },
                            pageTitle: 'Sign the contract 1/3 entering account number and address',
                            eventId: 2051
                        });
                        this.setState({redirectToNextStep: true});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/view_contract'}/>
        }

        return (<div>
            <Formik
                initialValues={this.state.data}
                onSubmit={this.formSubmit}
                render={this.renderForm}
                enableReinitialize={true}
            />
        </div>)
    }
}

export default withTranslation()(AML);
